module.exports = __webpack_public_path__ + "static/img/section1Bg1.e2dbc31f.png";